import { reactive } from 'vue'

/** Conversations the agent is working in right now, as seen by this client's open chat (drives the sidebar dot). */
export const workingSessionIds = reactive(new Set<string>())

export function setSessionWorking(id: string | null | undefined, on: boolean): void {
    if (!id) return
    if (on) workingSessionIds.add(id)
    else workingSessionIds.delete(id)
}
